import { render, staticRenderFns } from "./_Header-title.vue?vue&type=template&id=0da7464e&scoped=true&"
import script from "./_Header-title.vue?vue&type=script&lang=js&"
export * from "./_Header-title.vue?vue&type=script&lang=js&"
import style0 from "./_Header-title.vue?vue&type=style&index=0&id=0da7464e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7464e",
  null
  
)

export default component.exports